module.exports = __webpack_public_path__ + "img/WP2023-Dubai6.f9ae1403.jpg";